import React, {FC, ReactNode} from 'react';

import {HandlerOf} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconName} from '../../../../../../../libs/shared/ui/src/components/icon/icon';
import {renderReplyTextForMessageType} from '../../../../../../../srcCommon/inboxes/viewer/activity/message/messageViewerHelpers';
import {MessageTypesEnum} from '../../../../../../models/api/messageModel';
import {ReplyLocationsEnum} from '../../../../../../services/tracking';
import {MessageViewerAction} from './messageViewerAction';

/*
 * Props.
 */

interface MessageViewerActionReplyProps {
  iconName: IconName;
  onClick: HandlerOf<ReplyLocationsEnum>;
  messageType: MessageTypesEnum;
  textOverride?: ReactNode;
  isDisabled?: boolean;
}

/*
 * Component.
 */

export const MessageViewerActionReply: FC<MessageViewerActionReplyProps> = (props) => {
  const {iconName, onClick} = props;
  return (
    <MessageViewerAction
      iconName={iconName}
      onClick={() => onClick(ReplyLocationsEnum.BOTTOM_OF_CONVERSATION)}
      isDisabled={props.isDisabled}
    >
      {props.textOverride || renderReplyTextForMessageType(props.messageType)}
    </MessageViewerAction>
  );
};
